export const TopListData = [
  {
    id: 1,
    src: '/images/디피.jpg',
    alt: 'list-img',
    title: '미드나잇 인 소호',
    rate: '4.8',
    intro: '하루하루가 다르게 트렌드가 바뀌는 미술 시장을 낱낱이 파헤쳐 보다!',
  },
  {
    id: 2,
    src: '/images/갈대.jpg',
    alt: 'list-img',
    title: '어나니머스',
    rate: '5.0',
    intro:
      '정체를 숨긴채 미술계를 조롱하는 천재 화가 니부. 어느날 그의 대작이 발견 됐다는데?',
  },
  {
    id: 3,
    src: '/images/드로잉.JPG',
    alt: 'list-img',
    title: '롤링페이퍼',
    rate: '4.3',
    intro:
      '선천적인 청각장애를 앓고 있는 소녀 엘리. 드로잉을 통한 세상과의 소통을 시도해본다!',
  },
  {
    id: 4,
    src: '/images/나.JPG',
    alt: 'list-img',
    title: '러버',
    rate: '5.0',
    intro:
      '죽은 연인이 남기고 간 초상화가 경매에 낙찰 될 위험해 처했다! 작품을 지키기 위한 수잔의 눈물겨운 투쟁.',
  },
  {
    id: 5,
    src: '/images/신밧드의 모험2.jpg',
    alt: 'list-img',
    title: '미스터리 케이브',
    rate: '1.8',
    intro:
      '낚시를 하던 중 표류를 하게 된 팀. 눈을 떠보니 이곳은 동굴. 그러나 평범한 동굴이 아니다!',
  },
  {
    id: 6,
    src: '/images/파리.jpg',
    alt: 'list-img',
    title: '파리 인 더 레인',
    rate: '2.6',
    intro:
      '유례없는 극심한 가뭄에 시달리게 된 파리. 그러던 중 눈물을 흘리면 비를 내리게 하는 비범한 소년이 나타났다. 그의 정체는?',
  },
  {
    id: 7,
    src: '/images/드로잉.JPG',
    alt: 'list-img',
    title: '롤링페이퍼',
    rate: '4.3',
    intro:
      '선천적인 청각장애를 앓고 있는 소녀 엘리. 드로잉을 통한 세상과의 소통을 시도해본다!',
  },
  {
    id: 8,
    src: '/images/디피.jpg',
    alt: 'list-img',
    title: '미드나잇 인 소호',
    rate: '4.8',
    intro: '하루하루가 다르게 트렌드가 바뀌는 미술 시장을 낱낱이 파헤쳐 보다!',
  },
  {
    id: 9,
    src: '/images/갈대.jpg',
    alt: 'list-img',
    title: '어나니머스',
    rate: '5.0',
    intro:
      '정체를 숨긴채 미술계를 조롱하는 천재 화가 니부. 어느날 그의 대작이 발견 됐다는데?',
  },
  {
    id: 10,
    src: '/images/나.JPG',
    alt: 'list-img',
    title: '러버',
    rate: '5.0',
    intro:
      '죽은 연인이 남기고 간 초상화가 경매에 낙찰 될 위험해 처했다! 작품을 지키기 위한 수잔의 눈물겨운 투쟁.',
  },
  {
    id: 11,
    src: '/images/파리.jpg',
    alt: 'list-img',
    title: '파리 인 더 레인',
    rate: '2.6',
    intro:
      '유례없는 극심한 가뭄에 시달리게 된 파리. 그러던 중 눈물을 흘리면 비를 내리게 하는 비범한 소년이 나타났다. 그의 정체는?',
  },
  {
    id: 12,
    src: '/images/신밧드의 모험2.jpg',
    alt: 'list-img',
    title: '미스터리 케이브',
    rate: '1.8',
    intro:
      '낚시를 하던 중 표류를 하게 된 팀. 눈을 떠보니 이곳은 동굴. 그러나 평범한 동굴이 아니다!',
  },
];
